module.exports = __webpack_public_path__ + "img/dashao.b868ea60.png";